import {
  ListTable,
  LoadingSpinner,
  ModalMessage,
  ReviewsList,
  PaginationMenu,
} from "../../components";
import {
  Container,
  Row,
  Col,
  ToggleButton,
  ButtonGroup,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getStorageToken } from "../../utilities";
import {
  adminDeleteProductReviewApi,
  adminFetchUserReviewsApi,
} from "../../api/reviewsApi";
import { useSelector } from "react-redux";
import { adminFetchUserApi, setAdminStatusApi } from "../../api/usersApi";
import { adminFetchUserOrdersApi } from "../../api/ordersApi";


export default function AdminUserDetails() {
  // displays the user's info along with their 
  // order history and reviews history 
  // admin can edit the user's admin status and delete reviews

  const tableHeaders = ["Date", "Total", "Paid", "Delivered", "Cancelled"];
  const fieldNames = [
    "createdAt",
    ["orderTotal", "cartSubtotal"],
    "isPaid",
    "isDelivered",
    "isCancelled",
  ];
  
  const initialPaginationState = {
    pageNr: 1,
    totalNrOfPages: 1,
  };

  const { stayLoggedIn } = useSelector((state) => state.user);

  const { id } = useParams();
  const [orders, setOrders] = useState([]);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    isAdmin: false,
  });
  const [userReviews, setUserReviews] = useState([]);
  const [updateReviews, setUpdateReviews] = useState(true);
  const [updateOrders, setUpdateOrders] = useState(true);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [paginationStateOrders, setPaginationStateOrders] = useState(
    {...initialPaginationState}
  );
  const [paginationStateReviews, setPaginationStateReviews] = useState(
    {...initialPaginationState}
  );

  useEffect(() => {
    const ordersAbortController = new AbortController();
    const usersAbortController = new AbortController();

    const fetchOrders = async (pageNr = null) => {
      setIsLoading(true);
      try {
        const token = getStorageToken(stayLoggedIn);
        const res = await adminFetchUserOrdersApi(
          token,
          id,
          ordersAbortController.signal,
          pageNr
        );
        setIsLoading(false);
        return res;
      } catch (error) {
        setErrorMsg("Could not load order history. Please try again later.");
      }
    };
  
  const fetchUser = async () => {
    setIsLoading(true);
    try {
      const token = getStorageToken(stayLoggedIn);
      const res = await adminFetchUserApi(
        token,
        id,
        usersAbortController.signal
      );
      setIsLoading(false);
      return res;
    } catch (error) {
      setErrorMsg("Could not load user data. Please try again later.");
    }
  };

    if(updateOrders){
      setUpdateOrders(false);
      if (id) {
        fetchUser()
        .then((res) => setUserDetails(res))
        .catch((error) =>
          setErrorMsg("Could not load user data. Please try again later.")
        );
        
      const pageNrOrders = paginationStateOrders?.pageNr || 1;
      //fetch orders for that specific user
      fetchOrders(pageNrOrders)
        .then((res) => {
          setOrders(res.orders);
          setPaginationStateOrders({
            pageNr: res?.currPageNr || 1,
            totalNrOfPages: res?.totalNrOfPages || 1,
          });
        })
        .catch((error) =>
        setErrorMsg(
          "Could not load the order history. Please try again later."
          )
          );
        }
      }
    return () => {
      ordersAbortController.abort();
      usersAbortController.abort();
    };
  }, [updateOrders, id, paginationStateOrders?.pageNr, stayLoggedIn]);

  useEffect(() => {
    const reviewsAbortController = new AbortController();
    const fetchReviews = async (pageNr = null) => {
      setIsLoading(true);
      try {
        const token = getStorageToken(stayLoggedIn);
        const res = await adminFetchUserReviewsApi(
          token,
          id,
          reviewsAbortController.signal,
          pageNr
        );
        setIsLoading(false);
        return res;
      } catch (error) {
        setErrorMsg("Could not load reviews data. Please try again later.");
      }
    };

    if(updateReviews){
      setUpdateReviews(false);
      const pageNrReviews = paginationStateReviews?.pageNr || 1;
      //fetch reviews for that specific user
      if (id) {
      fetchReviews(pageNrReviews)
        .then((res) => {
          setUserReviews(res.reviews);
          setPaginationStateReviews({
            pageNr: res?.currPageNr || 1,
            totalNrOfPages: res?.totalNrOfPages || 1,
          });
        })
        .catch((error) =>
          setErrorMsg("Could not user reviews. Please try again later.")
        );
    }

      return () => {
        reviewsAbortController.abort();
      };
    }
  }, [updateReviews, paginationStateReviews?.pageNr, id, stayLoggedIn]);


  const handleChangeIsAdmin = async (newStatus) => {
    try {
      if (!newStatus === userDetails.isAdmin) {
        const token = getStorageToken(stayLoggedIn);
        const abortController = new AbortController();
        await setAdminStatusApi(
          token,
          id,
          newStatus,
          abortController.signal
        );
        setUserDetails({ ...userDetails, isAdmin: newStatus });
      }
    } catch (error) {
      setErrorMsg("Could not change admin status. Please try again later.");
    }
  };

  const handleDelete = async (reviewId) => {
    try {
      const token = getStorageToken(stayLoggedIn);
      await adminDeleteProductReviewApi(token, reviewId);
      setSuccessMsg("Successfully deleted the review.");
      setUpdateReviews(true);
    } catch (error) {
      setErrorMsg("Could not delete the review. Please try again later.");
    }
  };

  const handleChangePageNrOrders = (newPageNr) => {
    if (newPageNr < 1) {
      newPageNr = 1;
    } else if (newPageNr > paginationStateOrders.totalNrOfPages) {
      newPageNr = paginationStateOrders.totalNrOfPages;
    }
    setPaginationStateOrders({ ...paginationStateOrders, pageNr: newPageNr });
    setUpdateOrders(true);
  };

  const handleChangePageNrReviews = (newPageNr) => {
    if (newPageNr < 1) {
      newPageNr = 1;
    } else if (newPageNr > paginationStateReviews.totalNrOfPages) {
      newPageNr = paginationStateReviews.totalNrOfPages;
    }
    setPaginationStateReviews({ ...paginationStateReviews, pageNr: newPageNr });
    setUpdateReviews(true);
  };

  return (
    <Container className="mt-5">
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      {successMsg && (
        <ModalMessage
          type="success"
          autoClose={true}
          message={successMsg}
          setSuccessMsg={setSuccessMsg}
        />
      )}
      {isLoading && <LoadingSpinner />}
      <h1>User Details</h1>
      <Row className="mt-5 mx-1">
        <Col>
          <Row>
            <Col md={2}>
              <b>First Name: </b>
            </Col>
            <Col md={4}>{userDetails.firstName}</Col>
          </Row>
          <Row>
            <Col md={2}>
              <b>Last Name: </b>
            </Col>
            <Col md={4}>{userDetails.lastName}</Col>
          </Row>
          <Row>
            <Col md={2}>
              <b>Email: </b>
            </Col>
            <Col md={4}>{userDetails.email}</Col>
          </Row>

          {/* ADMIN STATUS TOGGLE BUTTON */}
          <Row className="mt-2">
            <Col md={2}>
              <b>Is Admin: </b>
            </Col>
            <Col md={4}>
              <ButtonGroup size="sm">
                <ToggleButton
                  id="radioYes"
                  type="radio"
                  variant="outline-success"
                  name="radioYes"
                  value={userDetails.isAdmin}
                  checked={userDetails.isAdmin}
                  disabled={userDetails?.doNotDelete}
                  onClick={() => handleChangeIsAdmin(true)}
                >
                  Yes
                </ToggleButton>
                <ToggleButton
                  id="radioNo"
                  type="radio"
                  variant="outline-danger"
                  name="radioNo"
                  value={userDetails.isAdmin}
                  checked={!userDetails.isAdmin}
                  disabled={userDetails?.doNotDelete}
                  onClick={() => handleChangeIsAdmin(false)}
                >
                  No
                </ToggleButton>
              </ButtonGroup>
              {userDetails?.doNotDelete && <p style={{fontSize: "small"}}>This is a demo user - their admin status cannot be changed.</p>}
            </Col>
          </Row>
        </Col>
      </Row>

      {/* USER'S ORDER HISTORY */}
      <Row className="mt-5">
        <h3>Order History</h3>
        {orders && orders.length > 0 ? (
          <Col md={10}>
            <ListTable
              dataArray={orders}
              headers={tableHeaders}
              fieldNames={fieldNames}
              view={`/admin/order-details`}
            />
            <PaginationMenu
              pageNr={paginationStateOrders.pageNr}
              totalNrOfPages={paginationStateOrders.totalNrOfPages}
              handleChangePageNr={handleChangePageNrOrders}
            />
          </Col>
        ) : (
          <p>This user has not placed any orders, yet.</p>
        )}
      </Row>

      {/* USER'S REVIEWS */}
      <Row className="mt-5">
        <h3>Reviews History</h3>
        {userReviews && userReviews.length > 0 ? (
          <Col md={10}>
            <ReviewsList
              reviews={userReviews}
              deletable={true}
              handleDelete={handleDelete}
            />
            <PaginationMenu
              pageNr={paginationStateReviews.pageNr}
              totalNrOfPages={paginationStateReviews.totalNrOfPages}
              handleChangePageNr={handleChangePageNrReviews}
            />
          </Col>
        ) : (
          <p>This user has not submitted any reviews, yet.</p>
        )}
      </Row>
    </Container>
  );
}
